import { Box, Typography } from '@mui/material';
import InvoiceCard from '../../Invoice/Components/InvoiceCard';
import GlassModal from '../../../v2/MUI_custom_component/Modal/GlassModal';
// import ReusableModal from '../../../v2/MUI_custom_component/Modal/CustomModal';

const ViewInvoiceList = ({ onClose, open, invoiceData }) => {

  return (
    <GlassModal
      open={open}
      onClose={onClose}
      title='Invoice Details'
      maxWidth='800px'
      // topMobile = '60%'
    >
      <InvoiceCard
        invoiceData={invoiceData}
        loading={false}
      />
    </GlassModal>
  );
};

export default ViewInvoiceList;
